import { saveAs } from "file-saver";
import { download as call } from "./";
import { Attachment } from "../types";

export function download(attachment: Attachment) {
  return call(`attachments/${attachment.id}/download`).then((blob) => {
    saveAs(blob, attachment.name);
  });
}
